import Cookies from 'js-cookie';
import type { PayHubCashierContractsPendingWithdrawalResponse } from 'store/models';
import { getWidgetLocation } from 'utils';

export const FULL_REVERSE_PERCENT = 100;

export type ReversePopupType = 'partial' | 'full' | 'none';

interface ReversePopupTypeParams {
  withdrawalReverseAmount?: number;
  pendingWithdrawals: PayHubCashierContractsPendingWithdrawalResponse[];
  isPartialReverseEnabled: boolean;
}

const hasPartialOption = ({ available_options }: PayHubCashierContractsPendingWithdrawalResponse) =>
  available_options.some((option) => option < FULL_REVERSE_PERCENT);

// Partial popup needs at least one withdrawal with an option below 100%, otherwise we fall back to the v1 popup,
// which needs the merchant-reported withdrawal_reverse amount.
export const getReversePopupType = ({
  withdrawalReverseAmount,
  pendingWithdrawals,
  isPartialReverseEnabled,
}: ReversePopupTypeParams): ReversePopupType => {
  if (isPartialReverseEnabled && pendingWithdrawals.some(hasPartialOption)) {
    return 'partial';
  }

  if (withdrawalReverseAmount) {
    return 'full';
  }

  return 'none';
};

export const isWithdrawalRejectBilletClosedCookieSet = (): boolean =>
  Boolean(Cookies.get('withdrawalRejectBilletClosed'));

export const setWithdrawalRejectBilletClosedCookies = (): void => {
  Cookies.set('withdrawalRejectBilletClosed', '1', {
    expires: 3, // days
    secure: true, // because without this parameter (true) - cookie do not set in iFrame
    sameSite: 'none',
  });
};

export const isPathnameOkForWithdrawalReject = (pathname: string): boolean => {
  const { isDeposit, isDepositForm } = getWidgetLocation(pathname);

  return isDeposit || isDepositForm;
};
